export default __webpack_public_path__ + "static/media/openxSvgNewLogo.182b091f.svg";